import { makeAutoObservable } from "mobx";
import { POST, DELETE, GET, PUT, PATCH, GET_USER } from "../apis/apis";
import { Button } from "antd";
import { message } from "antd";
import _ from "lodash";

class MarketplaceStore {
  constructor({ errStore }) {
    makeAutoObservable(this, {
      _historyItemId: false,
      _historyTimer: false,
      _historyAbortController: false,
      _historyRetryCount: false,
      _historyCycleStart: false,
      _historyRetrying: false,
    });
    this.errStore = errStore;
  }

  license = [];
  marketplaceItems = [];
  marketplaceItem = null;
  IsMarketplaceCreateModalOpen = false;
  cart = { items: [], purchase_info: [] };
  wishlist = { items: [] };
  wishlist_items_list = { key: "", label: <>''</> };
  cart_items_list = [];
  metaMaskIsConnected = false;
  play = false;
  audioSource = null;
  playingId = null;
  fetchingMarketplaceItems = false;
  fetchingMarketplaceItem = false;
  nftArray = [];
  loadingLastItem = false;
  ownership = [];
  listings = [];
  cartListings = [];
  cartCurrency = "";
  activeFilter = null;
  buyInProgress = false;
  historyProgressDisplay = 0;

  // Plain (non-observable) bookkeeping for the NFT transaction-history retry cycle.
  _historyItemId = null;
  _historyTimer = null;
  _historyAbortController = null;
  _historyRetryCount = 0;
  _historyCycleStart = null;
  _historyRetrying = false;

  setMarketplaceItem = (value) => {
    this.marketplaceItem = value;
  };

  setBuyInProgress(value) {
    this.buyInProgress = value;
  }

  setActiveFilter(value) {
    this.activeFilter = value;
  }

  setListings(value) {
    this.listings = value;
  }

  setOwnership(value) {
    this.ownership = value;
  }

  setNFTIsSelling(value) {
    this.NFT.listed = value;
  }

  setLoadingLastItem = (value) => {
    this.loadingLastItem = value;
  };

  setNftArray = (value) => {
    this.nftArray = value;
  };

  setFetchingMarketplaceItem = (value) => {
    this.fetchingMarketplaceItem = value;
  };

  setFetchingMarketplaceItems = (value) => {
    this.fetchingMarketplaceItems = value;
  };

  setPlayingId = (value) => {
    this.playingId = value;
  };

  setPlay = (value) => {
    this.play = value;
  };

  setAudio = (value) => {
    this.audioSource = value;
  };

  setMetaMaskIsConnected = (value) => {
    this.metaMaskIsConnected = value;
  };

  setLicense = (value) => {
    this.license = value;
  };

  setCart = (value) => {
    this.cart = value;
  };

  setCartItemsList = (value) => {
    this.cart_items_list = value;
  };

  setCartCurrency(value) {
    this.cartCurrency = value;
  }

  setIsMarketplaceCreateModalOpen = (value) => {
    this.IsMarketplaceCreateModalOpen = value;
  };

  setMarketplaceItems = (value) => {
    this.marketplaceItems = value;
  };

  CreatedMarketplaceItems = [];
  OwnedMarketplaceItems = [];

  setCreatedMarketplaceItems = (value) => {
    this.CreatedMarketplaceItems = value;
  };

  setOwnedMarketplaceItems = (value) => {
    this.OwnedMarketplaceItems = value;
  };

  polygon_icon = null;
  ethereum_icon = null;

  GetPolygonNetworkIcon = () => {
    GET(`/icon/${"polygon.png"}`)
      .then((data) => {
        this.polygon_icon = data.url;
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetEtheriumNetworkIcon = () => {
    GET(`/icon/${"ethereum.png"}`)
      .then((data) => {
        this.ethereum_icon = data.url;
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetCreatedMarketplaceItems = (username) => {
    this.errStore.setLoading(true);
    this.errStore.setItemsRequest("Server is not responding. Please wait ...");
    GET(`/user/created/${username}`)
      .then((data) => {
        this.setCreatedMarketplaceItems(data);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        this.errStore.setItemsRequest("");
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetOwnedMarketplaceItems = (username) => {
    this.errStore.setLoading(true);
    this.errStore.setItemsRequest("Server is not responding. Please wait ...");
    GET(`/user/owned/${username}`)
      .then((data) => {
        this.setOwnedMarketplaceItems(data);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        this.errStore.setItemsRequest("");
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  calculateItems = () => {};

  GetMarketplaceItems = (param) => {
    this.setFetchingMarketplaceItems(true);
    this.errStore.setItemsRequest("Server is not responding. Please wait ...");
    GET(`/marketplace-item/?ordering=${param}`)
      .then((data) => {
        this.GetNFT();
        this.setMarketplaceItems(data);
        this.errStore.setMessage("");
        this.errStore.setInfo(false);
        this.errStore.setItemsRequest("");
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      })
      .finally(() => {
        this.setFetchingMarketplaceItems(false);
      });
  };

  unlockable_source = "";
  unlockable_content_text = null;

  setUnlockableContentText = (value) => {
    this.unlockable_content_text = value;
  };
  setUnlockableContentSource = (value) => {
    this.unlockable_source = value;
  };

  UnlockContent = (id) => {
    this.errStore.setLoading(true);
    const values = {
      account: localStorage.getItem("metaMask"),
    };
    if (!values.account) {
      message.error("Please connect to Metamask");
      return;
    }
    POST(`/nft/${id}/unlock-content`, values)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        this.setUnlockableContentText(data.unlockable_content);
        this.setUnlockableContentSource(data.source);
      })
      .catch((error) => {
        if (error.response?.data === "User is not the owner of this NFT.") {
          message.error(
            `This wallet does not own the selected NFT. Please make sure you're connected to the correct MetaMask account.`,
          );
        }

        this.errStore.handlerErrors(error);
        this.errStore.setMessage(error.message);
        this.errStore.setInfo(true);
      });
  };

  PostMarketplaceNFTItemHash = (id, values) => {
    this.errStore.setLoading(true);
    PUT(`/tx/${id}`, values)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  marketplaceItemIsCreating = false;

  setMarketplaceItemIsCreating = (value) => {
    this.marketplaceItemIsCreating = value;
  };

  CreateMarketplaceItem = async (values) => {
    this.errStore.setLoading(true);
    this.setMarketplaceItemIsCreating(true);
    this.setLoadingLastItem(true);

    try {
      const data = await POST(`/marketplace-item/`, values);

      if (data.payload.chainId) {
        data.payload.gas = JSON.stringify(data.payload.gas);
        data.payload.maxFeePerGas = JSON.stringify(data.payload.maxFeePerGas);
        data.payload.maxPriorityFeePerGas = JSON.stringify(
          data.payload.maxPriorityFeePerGas,
        );

        const transactionObject = {
          from: data.payload.from,
          data: data.payload.data,
          to: data.payload.to,
          value: data.payload.value.toString(16),
        };

        const stopCreationTimer = setTimeout(() => {
          this.DeleteMarketplaceItemById(data.item.id);
          this.setLoadingLastItem(false);
        }, 90000);

        try {
          const txHash = await window.ethereum.request({
            method: "eth_sendTransaction",
            params: [transactionObject],
          });

          values = { tx_hash: txHash };
          let retries = 0;

          const getTransactionReceipt = async () => {
            try {
              const receipt = await window.ethereum.request({
                method: "eth_getTransactionReceipt",
                params: [txHash],
              });

              if (receipt?.status === "0x1") {
                clearTimeout(stopCreationTimer);
                this.setLoadingLastItem(false);
                this.PostMarketplaceNFTItemHash(data.tx_receipt, values);
                this.errStore.setLoading(false);
              } else if (receipt?.status === "0x0" && retries > 10) {
                message.warning(
                  "Item not created: The transaction failed, please try again later. IN ELSE",
                );
                this.setLoadingLastItem(false);
                clearTimeout(stopCreationTimer);
                this.DeleteMarketplaceItemById(data.item.id);
                this.errStore.setLoading(false);
              } else {
                if (retries < 10) {
                  retries++;
                  setTimeout(getTransactionReceipt, 5000);
                } else {
                  clearTimeout(stopCreationTimer);
                  this.DeleteMarketplaceItemById(data.item.id);
                  this.setLoadingLastItem(false);
                  this.errStore.setLoading(false);
                }
              }
            } catch (error) {
              message.warning(
                "Item not created: The transaction failed, please try again later. AT CATCH",
              );
              clearTimeout(stopCreationTimer);
              this.setLoadingLastItem(false);
              this.DeleteMarketplaceItemById(data.item.id);
              console.error("Transaction error:", error);
              this.errStore.setLoading(false);
            }
          };

          getTransactionReceipt();
        } catch (error) {
          clearTimeout(stopCreationTimer);
          this.setLoadingLastItem(false);
          this.DeleteMarketplaceItemById(data.item.id);
          console.error("Transaction error:", error);
          this.errStore.setLoading(false);
        }
      } else {
        this.setLoadingLastItem(false);
      }

      this.setIsMarketplaceCreateModalOpen(false);
      this.GetMarketplaceItems();
      this.errStore.setMessage("");
      this.setMarketplaceItemIsCreating(false);
      this.setSourceIsUploaded(false);
    } catch (error) {
      console.error("Error during marketplace item creation:", error);

      let errorMessage = "Item not created: The transaction failed.";

      if (error.response?.data?.error?.message) {
        errorMessage += ` ${error.response.data.error.message}`;
      } else if (
        error.message?.includes("NetworkError") ||
        error.message?.includes("CORS")
      ) {
        errorMessage += " Network error";
      }

      message.warning(errorMessage);
      this.setMarketplaceItemIsCreating(false);
      this.errStore.setLoading(false);
    }
  };

  UpdateMarketplaceItem = (id, values) => {
    this.errStore.setLoading(true);

    PATCH(`/marketplace-item/${id}`, values)
      .then((data) => {
        this.marketplaceItem = { ...this.marketplaceItem, ...data };
        data.nft !== null && this.GetNFTById(data.nft);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  DeleteMarketplaceItemById = (id) => {
    this.errStore.setLoading(true);
    DELETE(`/marketplace-item/${id}`)
      .then(() => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        for (var i = 0; i < this.marketplaceItems.length; i++) {
          if (this.marketplaceItems[i].id === id) {
            this.marketplaceItems.splice(i, 1);
            break;
          }
        }
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  source = null;

  setSource = (value) => {
    this.source = value;
  };
  GetBlobSourceById = (src) => {
    fetch(src)
      .then((response) => response.blob())
      .then((blob) => {
        const url = URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "image.png";
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.remove();
      });
  };

  GetSourceById = (id) => {
    this.errStore.setLoading(true);
    this.errStore.setItemsRequest("Server is not responding. Please wait ...");
    GET(`/source/${id}`)
      .then((data) => {
        this.setSource(data.media);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        this.errStore.setItemsRequest("");
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetMarketplaceItemById = (id) => {
    this.setFetchingMarketplaceItem(true);
    this._historyItemId = id;
    this._stopHistoryPolling();

    GET(`/marketplace-item/${id}`, { timeout: 40000 })
      .then((data) => {
        if (id !== this._historyItemId) return;
        this.marketplaceItem = data;
        if (data.item.nft !== null) {
          this.GetNFTById(data.item.nft);
        } else {
          this.setNFT(null);
        }
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        this._handleHistoryResponse(id, data);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      })
      .finally(() => {
        this.setFetchingMarketplaceItem(false);
      });
  };

  // Stops any pending automatic retry for the NFT transaction history:
  // clears the retry timer, aborts an in-flight retry request, and resets
  // the retry budget and displayed progress. Safe to call even when no
  // cycle is running. Call this from the consuming component's effect
  // cleanup (on unmount and before re-fetching a different item).
  StopMarketplaceItemHistoryPolling = () => {
    this._stopHistoryPolling();
  };

  // Manual "Try again" action for the history section. Re-fetches with
  // history_retry=1, resets the displayed progress to 0%, and - if the
  // response is still "loading" - starts a fresh 5-minute retry cycle.
  // Clicks are ignored while a retry cycle is already running.
  RetryMarketplaceItemHistory = (id) => {
    if (this._historyRetrying) return;

    this._historyItemId = id;
    this._stopHistoryPolling();
    this._historyRetrying = true;

    this.marketplaceItem = {
      ...this.marketplaceItem,
      events: [],
      events_status: "loading",
      events_progress: undefined,
    };

    const controller = new AbortController();
    this._historyAbortController = controller;

    GET(`/marketplace-item/${id}`, {
      params: { history_retry: 1 },
      timeout: 40000,
      signal: controller.signal,
    })
      .then((data) => {
        if (id !== this._historyItemId) return;
        this.marketplaceItem = {
          ...this.marketplaceItem,
          events: data.events,
          events_status: data.events_status,
          events_progress: data.events_progress,
        };
        this._handleHistoryResponse(id, data);
      })
      .catch((error) => {
        if (id !== this._historyItemId) return;
        if (error.name === "CanceledError" || error.name === "AbortError") return;
        this._setHistoryError(id);
      });
  };

  // Applies the history_status/history_progress from a response to local
  // state, and either schedules the next automatic retry (still "loading")
  // or stops the cycle ("ok"/"error"). Ignores stale responses for an item
  // the user has since navigated away from.
  _handleHistoryResponse = (id, data) => {
    if (id !== this._historyItemId) return;

    this._updateHistoryProgress(data.events_progress, data.events_status);

    if (data.events_status === "loading") {
      if (!this._historyCycleStart) {
        this._historyCycleStart = Date.now();
        this._historyRetryCount = 0;
      }
      this._historyRetrying = true;
      this._scheduleHistoryRetry(id);
    } else {
      this._stopHistoryPolling();
    }
  };

  _updateHistoryProgress = (progress, status) => {
    if (typeof progress !== "number" || Number.isNaN(progress)) return;
    const pct = Math.round(progress * 100);
    const capped = status === "loading" ? Math.min(pct, 99) : pct;
    if (capped > this.historyProgressDisplay) {
      this.historyProgressDisplay = capped;
    }
  };

  _scheduleHistoryRetry = (id) => {
    this._historyTimer = setTimeout(() => {
      this._fetchHistoryRetry(id);
    }, 10000);
  };

  _fetchHistoryRetry = (id) => {
    if (id !== this._historyItemId) return;

    const elapsed = Date.now() - this._historyCycleStart;
    if (this._historyRetryCount >= 30 || elapsed >= 5 * 60 * 1000) {
      this._setHistoryError(id);
      return;
    }
    this._historyRetryCount += 1;

    const controller = new AbortController();
    this._historyAbortController = controller;

    GET(`/marketplace-item/${id}`, {
      params: { history_retry: 1 },
      timeout: 40000,
      signal: controller.signal,
    })
      .then((data) => {
        if (id !== this._historyItemId) return;
        this.marketplaceItem = {
          ...this.marketplaceItem,
          events: data.events,
          events_status: data.events_status,
          events_progress: data.events_progress,
        };
        this._handleHistoryResponse(id, data);
      })
      .catch((error) => {
        if (id !== this._historyItemId) return;
        if (error.name === "CanceledError" || error.name === "AbortError") return;
        this._setHistoryError(id);
      });
  };

  _setHistoryError = (id) => {
    if (id !== this._historyItemId) return;
    this.marketplaceItem = {
      ...this.marketplaceItem,
      events: [],
      events_status: "error",
    };
    this._stopHistoryPolling();
  };

  _stopHistoryPolling = () => {
    if (this._historyTimer) {
      clearTimeout(this._historyTimer);
      this._historyTimer = null;
    }
    if (this._historyAbortController) {
      this._historyAbortController.abort();
      this._historyAbortController = null;
    }
    this._historyRetryCount = 0;
    this._historyCycleStart = null;
    this._historyRetrying = false;
    this.historyProgressDisplay = 0;
  };

  GetMarketplaceItemsByTypeOrName = (values) => {
    this.errStore.setLoading(true);
    GET(`/marketplace-item/${values.order}/${values.value}`)
      .then((data) => {
        this.setMarketplaceItems(data);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  PatchMarketPlaceNFTItemHash = (id, values) => {
    this.errStore.setLoading(true);

    PATCH(`/tx/${id}`, values)
      .then(() => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  async GetCartListings() {
    try {
      const listingIds = this.cart.purchase_info.map((info) => info.listing);

      const uniqueListingIds = [...new Set(listingIds)];

      const fetchedListings = await Promise.all(
        uniqueListingIds.map((id) => GET(`/listing/${id}`)),
      );
      this.cartListings = fetchedListings;
    } catch (error) {
      console.error("Failed to fetch listings:", error);
    }
  }

  GetCart = () => {
    this.errStore.setLoading(true);
    GET_USER(`/cart/`)
      .then((data) => {
        this.setCart(data);
        this.setCartCurrency(data.items_list[0]?.chainid ?? "");
        this.setCartItemsList([]);
        let temp = [];
        data.items_list.forEach((item, index) => {
          temp.push({
            key: item.id,
            label: (
              <Button key={index} type="link">
                {item.name}
              </Button>
            ),
          });
        });
        this.setCartItemsList(temp);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  DeleteCart = () => {
    this.errStore.setLoading(true);
    DELETE(`/cart/`)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  UpdateCart = (values) => {
    this.errStore.setLoading(true);
    PUT(`/cart/`, values)
      .then((data) => {
        this.setCart(data);
        this.setCartCurrency(data.items_list[0]?.chainid ?? "");
        let temp = [];
        data.items_list.forEach((item) => {
          temp.push({ key: item.id, label: <>{item.name}</> });
        });
        this.setCartItemsList(temp);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  CreateCart = () => {
    this.errStore.setLoading(true);
    POST(`/cart/`)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  setWishlist = (value) => {
    this.wishlist = value;
  };

  GetWishlist = () => {
    this.errStore.setLoading(true);
    GET(`/wishlist/`)
      .then((data) => {
        this.setWishlist(data);
        this.wishlist_items_list = data.items_list;
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  DeleteWishlist = () => {
    this.errStore.setLoading(true);
    DELETE(`/wishlist/`)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  UpdateWishlist = (values) => {
    this.errStore.setLoading(true);
    PUT(`/wishlist/`, values)
      .then((data) => {
        this.setWishlist(data);
        this.wishlist_items_list = data.items_list;
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  CreateWishlist = () => {
    this.errStore.setLoading(true);
    POST(`/wishlist/`)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  tags = [];
  setTags = (value) => {
    this.tags = value;
  };

  GetTags = () => {
    this.errStore.setLoading(true);
    GET(`/tag/`)
      .then((data) => {
        this.setTags(data);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetLicense = () => {
    GET_USER(`/license`)
      .then((data) => {
        this.setLicense(data);
        this.errStore.setMessage("");
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetNFT = () => {
    this.errStore.setLoading(true);
    GET(`/nft/`)
      .then((data) => {
        this.setNftArray(data);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetNFTById = (id) => {
    this.errStore.setLoading(true);
    GET(`/nft/${id}`)
      .then((data) => {
        this.setNFT(data);
        const filteredItems = this.marketplaceItems.filter(
          (item) => item.nft === id,
        );
        if (filteredItems.length > 0) {
          filteredItems[0].nft = data;
        }
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  DeleteNFT = (id) => {
    this.errStore.setLoading(true);
    DELETE(`/nft/${id}`)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  UpdateNFT = (id, values) => {
    this.errStore.setLoading(true);
    PATCH(`/nft/${id}`, values)
      .then((response) => {
        const nftNewArray = _.cloneDeep(this.nftArray);
        nftNewArray.forEach((nft) => {
          if (nft.id === id) {
            nft = response.data;
          }
        });
        this.setNftArray(nftNewArray);

        if (this.NFT?.id === id) {
          this.setNFT(response);
        }

        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        return response.data;
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
        this.errStore.setLoading(false);
      });
  };

  NFT = { name: "", price: "", license: "", sypply: "" };

  setNFT = (value) => {
    this.NFT = value;
  };

  CreateNFT = (values) => {
    this.errStore.setLoading(true);
    POST(`/nft/`, values)
      .then((data) => {
        this.setNFT(data);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  PostMarketPlaceNFTItemHash = async (id, values) => {
    this.errStore.setLoading(true);
    await PUT(`/tx/${id}`, values)
      .then(() => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  BuyNFT = async (id, values) => {
    try {
      this.errStore.setLoading(true);

      const data = await POST(`/nft/buy/${id}`, values);

      if (data.info.message) {
        this.errStore.setMessage(data.info.message);
        this.errStore.setInfo(true);
      }

      data.info.payload.gas = JSON.stringify(data.info.payload.gas);
      data.info.payload.maxFeePerGas = JSON.stringify(
        data.info.payload.maxFeePerGas,
      );
      data.info.payload.maxPriorityFeePerGas = JSON.stringify(
        data.info.payload.maxPriorityFeePerGas,
      );

      const transactionObject = {
        from: data.info.payload.from,
        data: data.info.payload.data,
        to: data.info.payload.to,
        value: data.info.payload.value.toString(16),
      };

      const txHash = await window.ethereum
        .request({
          method: "eth_sendTransaction",
          params: [transactionObject],
        })
        .catch((error) => {
          throw new Error(error);
        });

      const txValues = { tx_hash: txHash };
      await this.PostMarketPlaceNFTItemHash(data.receipt, txValues);
      message.success("Transaction successful");

      this.GetListingsById(id);
      this.GetOwnershipById(id);
    } catch (error) {
      const parsedData =
        typeof error.response?.data === "string"
          ? JSON.parse(error.response?.data.replace(/'/g, '"'))
          : error.response?.data;

      if (parsedData?.message.includes("insufficient funds")) {
        message.error(
          "Your funds are not sufficient to complete this transaction",
        );
      }

      throw new Error(error);
    } finally {
      this.errStore.setLoading(false);
    }
  };

  BatchBuyNFT = async (values) => {
    this.errStore.setLoading(true);

    await POST(`/nft/buy/batch`, values)
      .then((data) => {
        if (data.info.message) {
          this.errStore.setMessage(data.info.message);
          this.errStore.setInfo(true);
        }

        const payload = data.info.payload[0];

        const transactionObject = {
          from: payload.from,
          data: payload.data,
          to: payload.to,
          value: payload.value.toString(16),
        };

        window.ethereum
          .request({
            method: "eth_sendTransaction",
            params: [transactionObject],
          })
          .then((txHash) => {
            const values = { tx_hash: txHash };

            let retries = 0;
            const getTransactionReceipt = () => {
              window.ethereum
                .request({
                  method: "eth_getTransactionReceipt",
                  params: [txHash],
                })
                .then((receipt) => {
                  console.log("Transaction receipt:", receipt);

                  if (receipt?.status === "0x1") {
                    message.success("The transaction was successfull!");
                    this.setCartCurrency("");
                    if (Array.isArray(data.receipts)) {
                      data.receipts.forEach((receiptItem) => {
                        this.PatchMarketPlaceNFTItemHash(receiptItem, values);
                      });

                      const updateValues = {
                        items: [],
                        purchase_info: [],
                      };

                      this.UpdateCart(updateValues);
                    }

                    this.errStore.setLoading(false);
                  } else if (receipt?.status === "0x0") {
                    console.error("Transaction failed");

                    message.warning(
                      "The transaction failed, please try again later.",
                    );

                    this.errStore.setLoading(false);
                  } else {
                    if (retries < 10) {
                      setTimeout(() => {
                        retries++;
                        getTransactionReceipt();
                      }, 5000);
                    } else {
                      message.warning(
                        "The transaction failed, please try again later.",
                      );
                      this.errStore.setLoading(false);
                    }
                  }
                })
                .catch((error) => {
                  if (error?.code !== 4001) {
                    message.warning(
                      "The transaction failed, please try again later.",
                    );
                  }
                  console.error("Error fetching receipt:", error);
                  this.errStore.setLoading(false);
                });
            };

            getTransactionReceipt();
          })
          .catch((error) => {
            if (error?.code !== 4001) {
              message.warning(
                "The transaction failed, please try again later.",
              );
            }
            console.error("Transaction error:", error);
            this.errStore.setLoading(false);
          });
      })
      .catch((error) => {
        const parsedData =
          typeof error.response?.data.info.payload === "string"
            ? JSON.parse(error.response?.data.info.payload.replace(/'/g, '"'))
            : error.response?.data;

        if (parsedData?.message.includes("insufficient funds")) {
          message.error(
            "Your funds are not sufficient to complete this transaction",
          );
          return;
        }

        if (error?.code !== 4001) {
          message.warning("The transaction failed, please try again later.");
        }
        this.errStore.handlerErrors(error);
        this.errStore.setLoading(false);
      });
  };

  CreateSource = (values) => {
    POST(`/source`, values)
      .then((data) => {
        this.setSource(data);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  source_link = null;

  setSourceLink = (value) => {
    this.source_link = value;
  };

  sourceIsUploading = false;
  sourceIsUploaded = false;

  setSsourceIsUploading = (value) => {
    this.sourceIsUploading = value;
  };
  setSourceIsUploaded = (value) => {
    this.sourceIsUploaded = value;
  };

  AddSourceToIPFS = async (values) => {
    this.setSsourceIsUploading(true);
    try {
      const data = await POST(`/source/upload/ipfs`, values);
      this.setSourceLink(data.link);

      this.setSsourceIsUploading(false);
      this.setSourceIsUploaded(true);
    } catch (error) {
      this.errStore.handlerErrors(error);
      this.setSsourceIsUploading(false);
    }
  };

  GetOwnershipById = (id) => {
    GET(`/ownership/nft/${id}`)
      .then((data) => this.setOwnership(data))
      .catch((error) => console.error(error));
  };

  GetListingsById = (id) => {
    return new Promise((resolve, reject) => {
      GET(`/listing/nft/${id}`)
        .then((data) => {
          this.setListings(data);
          resolve(data);
          if (data.length === 0) {
            this.UpdateNFT(id, { listed: false });
          }
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        });
    });
  };

  PostListing = (values) => {
    POST(`/listing`, values)
      .then((data) => this.setListings([...this.listings, data]))
      .catch((error) => console.error(error));
  };

  PatchListing = (listingId, values) => {
    PATCH(`/listing/${listingId}`, values)
      .then((data) => {
        this.setListings(
          this.listings.map((listing) =>
            listing.id === data.id ? { ...listing, ...data } : listing,
          ),
        );
      })
      .catch((error) => console.error(error));
  };

  DeleteListing = (listingId) => {
    DELETE(`/listing/${listingId}`)
      .then(() => {
        this.setListings(
          this.listings.filter((listing) => listing.id !== listingId),
        );
      })
      .catch((error) => console.error(error));
  };
}

export default MarketplaceStore;
